import React, { Component } from 'react';
import { translate } from '../Services/translation';
class FacetedSearchGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      showLessItemCount: 5,
    };
    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  toggleShowMore() {
    this.setState(prevState => ({
      collapsed: !prevState.collapsed
    }));
  }

  render() {
    const { group, searchFacetChange } = this.props;
    const { collapsed, showLessItemCount } = this.state;
    const visibleOptions = collapsed 
      ? group.options.slice(0, showLessItemCount)
      : group.options;

    return (
      <div>
        <div className="faceted-search__group-header text-accent text-xl leading-[2.5rem] font-extrabold mb-3">
          {group.label}
        </div>

        <div className="relative overflow-hidden mb-4">
          <div 
            className={`grid transition-all duration-300 ease-in-out`}
            style={{
              gridTemplateRows: 'repeat(auto-fill, minmax(0, auto))'
            }}
          >
            {group.options.map((item, itemIndex) => (
              <div
                key={`${item.label}-${itemIndex}`}
                className={`faceted-search__item transition-opacity duration-300 ${
                  itemIndex >= visibleOptions.length ? 'opacity-0 h-0' : 'opacity-100 py-1.5'
                }`}
              >
                <FacetedFilterCheckbox
                  item={item}
                  group={group}
                  searchFacetChange={searchFacetChange}
                />
              </div>
            ))}
          </div>
          
        </div>
        
        {group.options.length > showLessItemCount && (
          <button 
            onClick={this.toggleShowMore}
            className="text-accent hover:underline text-sm font-extrabold cursor-pointer"
          >
            {collapsed 
                ? translate('filter.showmore')
                : translate('filter.showless')}
          </button>
        )}
      </div>
    );
  }
}

const FacetedSearch = ({ facetFilters, searchFacetChange, navigationTheme, clearFilters }) => {
  const hasSelectedFilters = facetFilters?.some(group => 
    group.selectedOptions && group.selectedOptions.length > 0
  );

  return (
    navigationTheme !== 'category' && (
      <div className="faceted-search space-y-8">
        {hasSelectedFilters && (
          <button 
            onClick={clearFilters}
            className="text-accent text-sm font-semibold mb-4 inline-flex items-center gap-1"
          >
            <span className='icon icon-outline text-sm!'>close</span>
            {translate('filter.clearall')}
          </button>
        )}
        {facetFilters &&
          facetFilters.map((group, groupIndex, array) => (
            <FacetedSearchGroup
              key={`${group.label}-${groupIndex}`}
              group={group}
              searchFacetChange={searchFacetChange}
            />
          ))}
      </div>
    )
  );
};

const FacetedFilterCheckbox = ({ item, group, searchFacetChange }) => (
  <label className="faceted-filter flex items-center gap-2 cursor-pointer">
    <input
      className="faceted-filter__input size-4"
      type="checkbox"
      onChange={(event) => searchFacetChange(group, item)}
      checked={
        group.selectedOptions != null && group.selectedOptions.includes(item.id)
      }
    />
    <span className="faceted-filter__label text-sm">
      {item.label}
      {!isNaN(item.quantity) && item.quantity != null && (
        <span className="faceted-filter__quantity text-text-tertiary">
          &nbsp;(
          {item.quantity})
        </span>
      )}
    </span>
  </label>
);

export default FacetedSearch;
